conferenceClient.directive('conferenceClient', [
    'templateCache',
    '$parse',
    'helperService',
    'logService',
    function (templateCache, $parse, helperService, logService) {
        return {
            restrict: 'E',
            template: templateCache.getTemplate(
                'conference_client/templates/' + helperService.getRedesignPathPrefix() + 'conferenceClient.html'
            ),
            link: function (scope, element, attrs, ngCtrl) {
                if (helperService.getDevicePlatform() === 'iOS') {
                    //$observe/$watch both return functions to de-register themselves
                    var stopObserve = attrs.$observe('ngShow', function (expr) {
                        var stopWatch = scope.$watch(
                            function () {
                                return $parse(expr)(scope);
                            },
                            function (feedVisible) {
                                if (feedVisible) {
                                    logService.log('Initial refresh for iOS RTC video feed');
                                    helperService.delayedWebRTCRefresh();

                                    stopWatch();
                                    stopObserve();
                                }
                            }
                        );
                    });
                }
            }
        };
    }
]);
